import Vuex from "vuex";
import http from "../components/WtHttp";

export class WtState {
  public user: {id: string, name: string, branch: any, role: string, password_completed: boolean} | null = null;
}

export default {
  namespaced: true,
  state: new WtState(),
  // state: {
  //   user:null
  // },
  getters: {
    is_teacher: (state: WtState) =>
      state.user != null && state.user.role == 'teacher',
    is_student: (state: WtState) =>
      state.user != null && state.user.role == 'student',
    top_url: (state: WtState, getters: any) => {
      if(state.user == null) return "#/sign_in";
      else if(state.user!.role == 'teacher') return "#/branch/results";
      else if(state.user!.role == 'student') return "#/student/top";
      else return "#/sign_in";   
    }
  },
  mutations: {
    user(state: any, params: any) {
      state.user = params.user;
    }
  },
  actions: {
    async load(commit: any) {
      const res = await http.get('./api/auth/current_user');
      commit.commit("user", { user: res.data });
    },

    sign_out(commit: any) {
      return http.delete("api/auth/sign_out").then(res => {
        commit.commit("user", { user: null });
      });
    }
  }
};
